import React, { useState } from 'react';
import Popover from 'react-tiny-popover';
import classnames from 'classnames';
import './tooltip.scss';

interface ITooltipProps {
    content: string;
    children: JSX.Element;
    className?: string;
}

const Tooltip = ({ content, children, className }: ITooltipProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Popover
            isOpen={isOpen}
            position='top'
            align='start'
            containerClassName='oe-tooltip-container'
            content={isOpen ? <div className={classnames('oe-tooltip', className)}>{content}</div> : null}
        >
            {(ref: React.Ref<HTMLDivElement>) =>
                React.cloneElement(children, {
                    ref: ref,
                    onMouseEnter: () => setIsOpen(true),
                    onMouseLeave: () => setIsOpen(false),
                })
            }
        </Popover>
    );
};

export { Tooltip };